import { render } from "./prems-section.vue?vue&type=template&id=6e8f9940"
import script from "./prems-section.vue?vue&type=script&lang=js"
export * from "./prems-section.vue?vue&type=script&lang=js"

import "./prems-section.vue?vue&type=style&index=0&id=6e8f9940&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__